import { ISlot } from 'constants/types';
import { listSlots } from 'lib/api/slots';
import { useEffect, useMemo, useState } from 'react';
import { useCurrentRegion } from './useCurrentRegion';

export const useSlotsPagination = ({
  collection,
}: {
  collection: string | string[] | undefined | null;
}) => {
  const limit = 12;

  const { isFetching: isCountriesFetching, currentRegion } = useCurrentRegion();

  const [count, setCount] = useState(-1);
  const [isFetching, setIsFetching] = useState(false);
  const [data, setData] = useState<ISlot[]>([]);
  const [currentCollection, setCurrentCollection] = useState(collection);

  const [page, setPage] = useState(
    data?.length ? Math.ceil(data?.length / limit) : 1
  );

  useEffect(() => {
    if (currentCollection !== collection) {
      setPage(1);
      setData([]);
      setCount(-1);
      setCurrentCollection(collection);
    }
  }, [currentCollection, collection]);

  useEffect(() => {
    const isCached = data.length > 0 && Math.ceil(data.length / limit) === page;

    if (!isCountriesFetching && !isCached && !isFetching) {
      setIsFetching(true);
      listSlots({
        page,
        limit,
        countries: currentRegion?._id,
        collections: collection?.toString() ?? '',
      })
        .then((response) => {
          const results = response.results ?? [];
          setData((current) =>
            page === 1 ? results : [...current, ...results]
          );
          setCount(Number(response.count ?? results.length));
        })
        .finally(() => setIsFetching(false));
    }
  }, [
    limit,
    page,
    currentCollection,
    isCountriesFetching,
    isFetching,
    collection,
    currentRegion?._id,
    data.length,
  ]);

  const isLast = useMemo(() => {
    if (count === -1) {
      return false;
    }

    return data.length >= count;
  }, [count, data.length]);

  return {
    page,
    data,
    isLast,
    setPage,
    isFetching,
    count: count < 0 ? 0 : count,
  };
};
